import { TABLE_EXPORT_MAX_RECORDS } from "@/constants/table-export-max-records";

const TRANSLATION_KEY = "boardMissions.tooManyRecordsPleaseFilter";

export function isTableExportRecordCountWithinLimit(count: number): boolean {
  return count <= TABLE_EXPORT_MAX_RECORDS;
}

/**
 * Shows a localized error when the dataset exceeds {@link TABLE_EXPORT_MAX_RECORDS}.
 * @returns true if export may proceed, false if blocked
 */
export function assertTableExportRecordCountWithinLimit(
  count: number,
  alertFault: (message: string) => void,
  t: (key: string) => string,
): boolean {
  if (!isTableExportRecordCountWithinLimit(count)) {
    alertFault(t(TRANSLATION_KEY));
    return false;
  }
  return true;
}
